import React, { useEffect, useState } from 'react';
import apiFetch from './apiClient';
import { ProfileInfoCard } from './profile/ProfileInfoCard';
import { ChangePasswordCard } from './profile/ChangePasswordCard';
import { AccountInfoCard } from './profile/AccountInfoCard';
import { ThemeCard } from './profile/ThemeCard';

const Profile = () => {
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);

    const fetchProfile = async () => {
        try {
            const response = await apiFetch('/api/profile/me');
            setUser(response);
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    return (
        <div className="min-vh-100 p-4">
            <div className="container-fluid" style={{ maxWidth: '1400px' }}>
                <h2 className="h4 fw-bold mb-4">Meu Perfil</h2>

                {error && <div className="alert alert-danger">{error}</div>}

                {!user && !error && <p className="text-muted-custom">Carregando perfil...</p>}

                {user && (
                    <div className="row g-4">
                        <div className="col-12 col-lg-8">
                            <ProfileInfoCard user={user} onSaved={fetchProfile} />
                        </div>
                        <div className="col-12 col-lg-4">
                            <AccountInfoCard user={user} />
                        </div>
                        <div className="col-12 col-lg-4">
                            <ThemeCard />
                        </div>
                        <div className="col-12 col-lg-8">
                            <ChangePasswordCard />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Profile;
